export enum NotifType
{
    SNACKBAR = 0,
    POPIN = 1,
    BOTH = 2
}
